import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import "./WirelessKey.css";
import EquipmentButtonIcons from "../../../constants/EquipmentButtonIcon";
import ErrorToast from "../../toasts/ErrorToast";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const WirelessKey = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  commands,
  setCommands,
}) => {
  const {
    addScenarioCommandDetail,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
    equipmentButtons,
  } = useContext(Context);
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleClickButton = (button, icon) => {
    if (
      button.data1 &&
      button.data2 &&
      button.data3 &&
      button.data4 &&
      button.data5
    ) {
      if (scenarioCommandDetail.id) {
        // setIsLoading(true);
        setCommands((prevCommands) =>
          scenarioCommands.map((command) =>
            command.id == scenarioCommandDetail.id
              ? {
                  ...command,
                  device_id: button.device_id,
                  time: scenarioCommandDetail.time,
                  data1: 5,
                  data2: button.data1,
                  data3: button.data2,
                  data4: button.data3,
                  data5: button.data4,
                  data6: button.data5,
                  data7: null,
                  data8: null,
                  data9: null,
                  data10: null,
                  data11: null,
                  command_name: String(button.name),
                  icon: button.icon,
                }
              : command
          )
        );
        closeSelectEquipmentRef.current.click();
        closeSelectOutputEquipmentRef.current.click();
        // UpdateScenarioCommand({
        //   scenario_command_id: scenarioCommandDetail.id,
        //   device_id: button.device_id,
        //   time: scenarioCommandDetail.time,
        //   data1: 5,
        //   data2: button.data1,
        //   data3: button.data2,
        //   data4: button.data3,
        //   data5: button.data4,
        //   data5: button.data5,
        //   command_name: button.name,
        //   icon: icon,
        // }).then(({ data: data1 }) => {
        //   SuccessToast("دستور با موفقیت جایگزین شد");
        //   const newScenarioCommands = scenarioCommands.map((scn) => {
        //     if (scn.id === scenarioCommandDetail.id) {
        //       return {
        //         ...scn,
        //         device_id: button.device_id,
        //         time: scenarioCommandDetail.time,
        //         data1: 5,
        //         data2: button.data1,
        //         data3: button.data2,
        //         data4: button.data3,
        //         data5: button.data4,
        //         data5: button.data5,
        //         command_name: button.name,
        //         icon: icon,
        //       };
        //     }
        //     return scn;
        //   });
        //   setScenarioCommands(newScenarioCommands);
        //   closeSelectEquipmentRef.current.click();
        //   closeSelectOutputEquipmentRef.current.click();
        //   setIsLoading(false);
        // });
      } else {
        setCommands((prev) => [
          ...prev,
          {
            id: new Date().getTime(),
            scenario_id: addScenarioCommandDetail.scenario_id,
            data1: 5,
            data2: button.data1,
            data3: button.data2,
            data4: button.data3,
            data5: button.data4,
            data6: button.data5,
            data7: null,
            data8: null,
            data9: null,
            data10: null,
            data11: null,
            icon: icon,
            command_name: String(button.name),
            device_id: button.device_id,
            time: 500,
          },
        ]);
        closeSelectEquipmentRef.current.click();
        closeSelectOutputEquipmentRef.current.click();
        // setIsLoading(true);
        // CreateScenarioCommand({
        //   scenario_id: addScenarioCommandDetail.scenario_id,
        //   data1: 5,
        //   data2: button.data1,
        //   data3: button.data2,
        //   data4: button.data3,
        //   data5: button.data4,
        //   data6: button.data5,
        //   icon: icon,
        //   command_name: button.name,
        //   device_id: button.device_id,
        //   time: 500,
        // }).then(({ data }) => {
        //   SuccessToast("دستور با موفقیت اضافه گردید");
        //   setScenarioCommands([...scenarioCommands, data.scenario_command]);
        //   closeSelectEquipmentRef.current.click();
        //   closeSelectOutputEquipmentRef.current.click();
        //   setIsLoading(false);
        // });
      }
    } else {
      ErrorToast("کلید تعریف نشده است");
    }
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      if (button.digit) {
        return null;
      }
      let iconPath = "/assets/img/custom-equipment-button/1.png";
      let iconId = 1;
      if (button.icon) {
        let buttonIcon = EquipmentButtonIcons.find(
          (icon) => icon.id == button.icon
        );
        iconId = buttonIcon.id;
        iconPath = buttonIcon.path;
      }
      let switch_keys = buttons
        .filter((btn) => btn.digit === button.id) // Filters to get matching results
        .sort((a, b) => a.id - b.id); // Sorts the results by `id`
      return (
        <div className="wireless-key d-flex  justify-content-around">
          <div className="d-flex justify-content-between wireless-key-icon">
            <div
              className="switch"
              onClick={() => handleClickButton(switch_keys[0], iconId)}
            >
              <div className="icon-part">
                <img src={iconPath} alt="" />
              </div>
              <div className="status-part danger"></div>
            </div>
            <div
              className="switch"
              onClick={() => handleClickButton(switch_keys[1], iconId)}
            >
              <div className="icon-part">
                <img src={iconPath} alt="" />
              </div>
              <div className="status-part success"></div>
            </div>
          </div>
          <div className="wireless-key-title align-self-center ms-3">
            <strong>{button.name}</strong>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: "0" }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
      </div>
      <div className="card-body scrollbar d-flex flex-wrap">
        <div className="wireless-keys">
          {/* <SimpleBar style={{ maxHeight: "100%", padding: "0.3rem" }}> */}
            {renderButtons()}
          {/* </SimpleBar> */}
        </div>
      </div>
    </div>
  );
};

export default React.memo(WirelessKey);
